import endpoints from 'helper/endpoints'
import {fireErrorToast, fireSuccessToast, globalApiErrorHandler} from 'helper/functions'
import httpClient from 'helper/httpClient'
import React from 'react'
import {
  GET_COMPANY_FAIL,
  GET_COMPANY_LIST_FAIL,
  GET_COMPANY_LIST_REQUEST,
  GET_COMPANY_LIST_SUCCESS,
  GET_COMPANY_REQUEST,
  GET_COMPANY_SUCCESS,
} from 'redux/actionType'
import {Trans} from '@lingui/macro'

export const getCompanyList = (limit = 1000, offset = 0, meta, search) => {
  return (dispatch) => {
    dispatch({type: GET_COMPANY_LIST_REQUEST})
    const searchQuery = search ? `?search=${search}` : ''
    return httpClient
      .get(endpoints.companies + searchQuery, {
        limit: limit,
        offset: offset,
        order_by:
          meta?.orderBy && meta?.orderDirection && `${meta?.orderBy}:${meta?.orderDirection}`,
      })
      .then((res) => {
        dispatch({type: GET_COMPANY_LIST_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_COMPANY_LIST_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const getCompany = (id) => {
  return (dispatch) => {
    dispatch({type: GET_COMPANY_REQUEST})
    return httpClient
      .get(endpoints.companies + '/' + id)
      .then((res) => {
        dispatch({type: GET_COMPANY_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_COMPANY_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const createCompany = (data) => {
  return (dispatch) => {
    return httpClient
      .post(endpoints.companies, data)
      .then((res) => {
        fireSuccessToast(<Trans>New company created.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}

export const patchCompany = (id, data) => {
  return (dispatch) => {
    return httpClient
      .patch(endpoints.companies + '/' + id, data)
      .then((res) => {
        fireSuccessToast(<Trans>Company updated.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}
